import React, { useContext, useMemo } from 'react';
import styles from './RecordCompareRecordCard.module.scss';
import { Column } from '../../Layout/RecordCompareLayout';
import useRecordLabel from '../../../hooks/useRecordCompareLabel';
import CompareContext from '../RecordCompareContext';
import PropertyTitle from '../RecordComparePropertyTitle';
import I18n from '../../../../I18n/I18n/I18n';
import getOr from '../../../../utils/getOr';
import { injectIntl } from 'react-intl';
var getTitle = getOr({})('ui:title');
function ReadOnlyCard(_ref) {
  var recordIndex = _ref.recordIndex,
    property = _ref.property,
    checked = _ref.checked,
    intl = _ref.intl;
  var _useContext = useContext(CompareContext),
    mergeRecord = _useContext.mergeRecord;
  var uiSchema = mergeRecord.uiSchema;
  var _useRecordLabel = useRecordLabel(recordIndex, property),
    label = _useRecordLabel.label,
    isEmpty = _useRecordLabel.isEmpty,
    uri = _useRecordLabel.uri;
  var propUiSchema = uiSchema[property];
  var _getTitle = getTitle(propUiSchema),
    text = _getTitle.text;
  var cardLabel = useMemo(function () {
    if (isEmpty) {
      return intl.formatMessage({
        id: label
      }, {
        label: '[' + text + ']'
      });
    }
    return label;
  }, [isEmpty, label, property]);
  return /*#__PURE__*/React.createElement(Column, {
    className: "".concat(styles['read-only-card']).concat(isEmpty ? " ".concat(styles.empty) : '')
  }, /*#__PURE__*/React.createElement(PropertyTitle, {
    property: property,
    recordIndex: recordIndex,
    readOnly: true
  }), /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.description, " auto-label auto-label-").concat(property, "-").concat(recordIndex)
  }, uri ? /*#__PURE__*/React.createElement("a", {
    href: uri,
    className: styles.download
  }, cardLabel, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, ' ', /*#__PURE__*/React.createElement(I18n, {
    i18n: cardLabel
  }))) : cardLabel));
}
export default injectIntl(ReadOnlyCard);